import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Box } from "@mui/material";

const PublicLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Box component="main" sx={{ minHeight: 'calc(100vh - 128px)' }}>
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default PublicLayout;